import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import { Tabs } from "@ubnt/ui-components/Tabs";
import styled, { css } from "styled-components";

export const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-bottom: 72px;
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
}
`;

export const ActiveVideoWrapper = styled.div`
  aspect-ratio: 1536/1600;
  position: relative;
  overflow: visible;
  width: 100%;
  height: 100%;
`;

export const ActiveVideo = styled.video<{ $isActive?: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  background: #f7f7f7;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0;
  transition: opacity 1.5s ease-out;

  ${({ $isActive }) =>
    $isActive &&
    css`
      transition: opacity 0.2s ease-in;
      z-index: 1;
      opacity: 1;
      left: 0;
    `}
`;
export const BackgroundVideo = styled.video<{ $isVisible: boolean }>`
  height: 100%;
  width: 100%;
  aspect-ratio: 1536/1600;
  border-radius: 16px;
  position: relative;
  background: #f7f7f7;
  z-index: 5;

  ${({ $isVisible }) =>
    !$isVisible &&
    css`
      visibility: hidden;
    `}
`;

export const Title = styled.h1<{ $isWhite: boolean }>`
  color: #212427;
  font-size: 30px;
  font-weight: 700;
  line-height: normal;
  position: relative;
  margin: 0;
  z-index: 8;
  text-align: center;
  text-wrap: pretty;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 24px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 20px;
  }

  ${({ $isWhite, theme }) =>
    $isWhite &&
    css`
      color: ${theme.colors.white};
    `}
`;

export const Description = styled.p`
  margin: 0;
  color: #808893;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
`;

export const Content = styled.div`
  position: absolute;
  top: 4%;
  width: 100%;
  left: 0;
  z-index: 7;
`;

export const TooltipTriggerWrapper = styled.div`
  position: absolute;
  bottom: 4.75%;
  width: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  gap: 8%;
  margin: 0 1%;
  height: 9.5%;
  transform: translate(-50%, -50%);
`;

export const TooltipTriggerBtn = styled.button<{
  $left: string;
  $isVisible: boolean;
}>`
  left: ${({ $left }) => `${$left}`};
  bottom: 0;
  position: absolute;
  width: 10.35%;
  height: 9.88%;
  background: transparent;
  border: none;
  visibility: hidden;
  display: block;
  border-radius: 18%;
  transform: translate(-50%, -50%);
  pointer-actions: none;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      visibility: visible;
      z-index: 99;
      pointer-actions: auto;
    `}
`;

export const Tooltip = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  width: 100%;
  left: -100%;
  min-height: 96px;
  padding: 0 12px;
  z-index: 100;
  background: transparent;
  justify-content: center;
  bottom: 0;
  transform: translateY(90%);
  opacity: 0;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      display: flex;
      left: 0;
      opacity: 1;
    `}
`;

export const TooltipContentWrap = styled.div`
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 24px 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(8px);
  max-width: 100%;
  gap: 4px;
`;

export const TooltipTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: #212427;
  font-weight: 700;
`;

export const TooltipDescription = styled.span`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: #808893;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const StyledTabs = styled(Tabs)`
  margin-top: 8px;

  .tabs {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #eeeff1;
  }

  .tab {
    > span {
      display: flex;
      align-items: center;
      color: #676f79;

      svg {
        bottom: 0;
        color: #808893;
        transition: color 0.15s linear;
        margin-right: 4px;
      }
    }

    &:hover:not(.selected-tab) {
      > span {
        color: ${({ theme }) => theme.colors.primaryBlue} !important;

        svg {
          color: ${({ theme }) => theme.colors.primaryBlue};
        }
      }
    }
  }

  .selected-tab {
    background: ${({ theme }) => theme.colors.primaryBlue} !important;

    > span {
      color: ${({ theme }) => theme.colors.white} !important;

      svg path {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;
